/**
 * Accepts an existing object and adds the new value to that object
 * Preferably used in loops of any kind in replacement of spreading
 * the existing object
 *
 * @example
 * list.reduce((acc, item) => addValueToMutableObject(acc, item.id, item));
 */
export const addValueToMutableObject = <T extends any>(
  acc: Record<string, T> = {},
  key: string | null,
  value: T
) => {
  if (!key) return acc;

  const newObject = acc || {};
  newObject[key] = value;
  return newObject;
};
